import React from "react";
import styles from "./layoutWrapper.module.scss";

const LayoutWrapper = ({ children }: { children: React.ReactNode }) => {
	return (
		<div className={styles.layoutWrapperContainer}>
			<div className={styles.innerContainer}>{children}</div>
		</div>
	);
};
export default LayoutWrapper;
